export const moveFocusToNextElement = (currentElement: HTMLElement | null) => {
  if (!currentElement) return

  const focusableElements = Array.from(
    document.querySelectorAll<HTMLElement>(
      `input:not([disabled]):not([tabindex="-1"]),
      button:not([disabled]):not([tabindex="-1"]),
      textarea:not([disabled]):not([tabindex="-1"]):not(.toastui-editor-pseudo-clipboard),
      select:not([disabled]):not([tabindex="-1"]),
      [tabindex]:not([tabindex="-1"]):not(.toastui-editor-pseudo-clipboard):not(.tab-item),
      div.ProseMirror.toastui-editor-contents[contenteditable="true"]`,
    ),
  ).filter((el) => {
    const style = window.getComputedStyle(el)
    return (
      !el.hasAttribute("disabled") &&
      !el.getAttribute("aria-hidden") &&
      el.offsetParent !== null &&
      style.opacity !== "0" &&
      style.visibility !== "hidden"
    )
  })

  const currentIndex = focusableElements.indexOf(currentElement)
  const nextElement = focusableElements[currentIndex + 1]
  nextElement?.focus()
}
